import ShortStats from './ShortStats';

export default ShortStats;
